import i18n from '@/plugins/i18n';
import { convertMilliseconds } from '@/utils/helper-function';

const amqOverviewMetricsData = () => [
  {
    metricName: 'artemis_broker_uptime_millis',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.uptime'),
    textValColor: 'tangerine',
    textValue: '0',
    transform: (value) => convertUptime(value),
    dataType: 'string',
  },
  {
    metricName: 'artemis_broker_producer_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfProducers'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'artemis_broker_consumer_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfConsumers'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'artemis_broker_queue_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfQueues'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'artemis_broker_memory_limit',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.memoryLimit'),
    textValColor: 'tangerine',
    textValue: '0',
    transform: (value) => (value ? value / (1024 * 1024 * 1024) : value),
    unit: 'GB',
  },
  {
    metricName: 'artemis_broker_topic_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.topicCount'),
    textValColor: 'tangerine',
    textValue: '0',
  },
];

function convertUptime(value) {
  const dateObject = convertMilliseconds(value);
  if (dateObject.days > 0) {
    return `${dateObject.days} days ${dateObject.hours} hours`;
  } else if (dateObject.hours > 0) {
    return `${dateObject.hours} hours ${dateObject.minutes} minutes`;
  } else if (dateObject.minutes > 0) {
    return `${dateObject.minutes} minutes ${dateObject.seconds} seconds`;
  } else if (dateObject.seconds > 0) {
    return `${dateObject.seconds} seconds ${dateObject.milliseconds} milliseconds`;
  }
  return `${value} milliseconds`;
}

export { amqOverviewMetricsData };
